var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 42.5",
    style: {
      enableBackground: "new 0 0 39.7 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,21.7l-7.8-7.8c-1.6-1.6-3.2-3.2-4.8-4.8C7,8.5,6.9,7.3,7.5,6.5c0.1-0.1,0.2-0.2,0.3-0.3C9,5,10.2,3.8,11.4,2.6 c0.6-0.8,1.7-0.9,2.5-0.3C14,2.4,14,2.5,14.1,2.6l17.8,17.8c0.8,0.5,1,1.6,0.5,2.3c-0.1,0.2-0.3,0.3-0.5,0.5 C26,29.1,20.1,35,14.1,40.9c-0.6,0.8-1.7,0.9-2.4,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-1.2-1.2-2.3-2.3-3.5-3.5s-1-2,0-3 c3.9-4,7.9-7.9,11.9-11.9C20,22.2,20.2,22,20.5,21.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.17d6c229167b9a9342c5e496116278a9.svg";
export { ForwardRef as ReactComponent };